/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {translate} from '@ion/core/src/locale/locale';
import Slider from '@ion/dls/src/components/slider/Slider';
import {dlsColor} from '../../../theme/theme';
import {
  LayerSettingsMarks,
  LayerSettingsSubLayersProps
} from '../../layers/LayerSettings';

const useStyles = makeStyles(() => ({
  subLayersSlider : {
    width     : '95%',
    display   : 'block',
    marginTop : '25px'
  },
  subLayersHeader : {
    fontFamily    : 'Roboto',
    fontStyle     : 'normal',
    fontWeight    : 500,
    fontSize      : '10px',
    lineHeight    : '16px',
    letterSpacing : '1px',
    textTransform : 'uppercase',
    display       : 'inline-block',
    color         : dlsColor('grey2')
  }
}));

const Opacity = ({
  opacity = 1,
  changeOpacity,
  title
}: LayerSettingsSubLayersProps) => {
  const [value, setValue] = useState(opacity);

  useEffect(() => {
    setValue(opacity);
  }, [opacity]);

  useEffect(() => {
    changeOpacity({title, opacity: value});
  }, [value]);

  const classes: any = useStyles();

  const handleChange = (e, value) => {
    setValue(value);
  };

  return (
    <div style={{marginTop: '-20px'}}>
      <div className={classes.subLayersSlider}>
        <span className={classes.subLayersHeader}>
          {translate('maps:operationalLayers.opacity')}
        </span>
        <Slider step={0.1}
          marks={LayerSettingsMarks}
          value={value}
          max={1}
          onSlide={function(e, val) { handleChange(e, val); }} />
      </div>
    </div>
  );
};

export default Opacity;
